import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { logger } from "utils/logger";
import { siteConfig } from "../configuration/config";
import { useSettings } from "./use-settings";

export function useIntroRedirect() {
  const [redirectingToIntro, setRedirectingToIntro] = useState(false);
  const router = useRouter();
  const { settings, settingsAreLoading } = useSettings();

  useEffect(() => {
    if (siteConfig.hideIntroFlow || settingsAreLoading) {
      return;
    }

    if (settings.firstVisit && router.pathname !== "/app/intro") {
      logger.info("First visit: redirecting to intro...");
      router.push("/app/intro");
      setRedirectingToIntro(true);
    } else if (redirectingToIntro && settings.firstVisit) {
      setRedirectingToIntro(false);
    }
  }, [router, settings, redirectingToIntro, settingsAreLoading, setRedirectingToIntro]);

  return {
    redirectingToIntro,
  };
}
